import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { GetSkillPathwayQueryQuery } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/GetSkillPathwayQuery';

type SkillPathwayData = NonNullable<
  NonNullable<GetSkillPathwayQueryQuery['VerifiedSkills']>['getSkillPathwayByBadgeIdForCurrentUser']
>;

type SkillPathwayContextType =
  | {
      skillPathway?: SkillPathwayData | null;
      isSkillPathwayLoading?: boolean;
      error?: ApolloError;
    }
  | undefined;

const SkillPathwayContext = React.createContext<SkillPathwayContextType>(undefined);

export const useSkillPathway = () => {
  const context = useContext(SkillPathwayContext);

  return context?.skillPathway;
};

export const useIsSkillPathwayLoading = () => {
  const context = useContext(SkillPathwayContext);

  return context?.isSkillPathwayLoading;
};

export const useSkillPathwayError = () => {
  const context = useContext(SkillPathwayContext);

  return context?.error;
};

export default SkillPathwayContext;
